module.exports = __webpack_public_path__ + "static/media/kv-all-live-games.788acadb.jpg";